import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';

function toInputValue(value) {
  if (!value) return '';
  const match = String(value).match(/^(\d{1,2}):(\d{2})/);
  if (!match) return '';
  return `${match[1].padStart(2, '0')}:${match[2]}`;
}

function toApiValue(inputValue) {
  if (!inputValue) return null;
  const match = String(inputValue).match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return null;
  return `${match[1].padStart(2, '0')}:${match[2]}:00`;
}

export default function SchoolDefaultTimesField({
  schoolId,
  defaultDismissalTime,
  token,
  onSaved,
  disabled = false,
}) {
  const [dismissal, setDismissal] = useState(toInputValue(defaultDismissalTime));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [savedAt, setSavedAt] = useState(0);

  useEffect(() => {
    setDismissal(toInputValue(defaultDismissalTime));
  }, [defaultDismissalTime]);

  const dirty = dismissal !== toInputValue(defaultDismissalTime);

  const handleSave = async () => {
    setError('');
    setSaving(true);
    try {
      const apiDismissal = toApiValue(dismissal);
      await apiFetch(`/schools/${schoolId}`, {
        method: 'PUT',
        body: JSON.stringify({
          default_dismissal_time: apiDismissal,
        }),
      }, token);
      onSaved?.({
        default_dismissal_time: apiDismissal,
      });
      setSavedAt(Date.now());
    } catch (err) {
      setError(err.message || 'Could not save dismissal start time');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ssp-default-times">
      <div className="ssp-default-times-row">
        <label className="ssp-default-time-field">
          <span>General Default</span>
          <input
            type="time"
            value={dismissal}
            onChange={(event) => setDismissal(event.target.value)}
            disabled={disabled || saving}
          />
        </label>
      </div>

      <div className="ssp-default-times-actions">
        <button
          type="button"
          className="sa-btn sa-btn-primary"
          onClick={handleSave}
          disabled={disabled || saving || !dirty}
        >
          {saving ? 'Saving…' : 'Save General Default'}
        </button>
        {!dirty && savedAt ? <span className="ssp-default-times-saved">Saved</span> : null}
      </div>

      {error ? <div className="sa-error" style={{ marginTop: 6 }}>{error}</div> : null}
    </div>
  );
}
